/**
 * @param {Element} section
 */
async function fetchAndRenderSection( section ){
    // Eg: template--24951451419004__multicolumn_YeeTcC
    let id = section.dataset.section_id;
  
    let response = await fetch(`/?section_id=${id}`)
    .then( response => response.text())
    .then( markup => {
        section.outerHTML = markup;        
    } );
  }
  
  
  
  function replaceSections() {
  
      let sections = document.querySelectorAll('[data-section-type="reference-section"]');
  
      if(sections){
            sections.forEach(function (section, currentIndex, listObj) {
                  // console.log(`${section}, ${currentIndex}, ${this}`);
                    fetchAndRenderSection(section);
                });
      }          
  }
          //console.log(markup);
           
  replaceSections();
  